import React from 'react';

const BAND_STYLES = {
  A: 'bg-emerald-50 text-emerald-700 border-emerald-200',
  B: 'bg-sky-50 text-sky-700 border-sky-200',
  C: 'bg-amber-50 text-amber-700 border-amber-200',
  D: 'bg-red-50 text-red-700 border-red-200',
};

export const VendorBandBadge = ({ band, score }) => {
  if (!band || band === '—') {
    return (
      <span data-testid="vendor-band-none" className="text-[11px] text-slate-400">
        No history
      </span>
    );
  }
  const pct = typeof score === 'number' ? ` · ${(score * 100).toFixed(0)}%` : '';
  return (
    <span
      data-testid={`vendor-band-${band}`}
      title={score != null ? `Avg performance score ${(score * 100).toFixed(0)}%` : `Performance band ${band}`}
      className={`tag border font-display font-bold ${BAND_STYLES[band] || 'bg-slate-100 text-slate-600 border-slate-200'}`}
    >
      {band}{pct}
    </span>
  );
};

export default VendorBandBadge;
